<section class="rs-content-wrapper rs-header-has-level2" id="PXS+InternetDetails">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <ng-container *ngIf="selectedProduct; else skeleton">
            <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
              {{ selectedProduct?.productDescription }}
            </h1>
            <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
              {{ selectedProduct?.accessNumber }}
            </p>
          </ng-container>
          <ng-template #skeleton>
            <div class="small-only-text-center">
              <div
                class="panel rs-inline-block rs-wd-s30 rs-wd-m31 rs-h-s4 rs-h-m5 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
            <div class="small-only-text-center">
              <div>
                <div
                  class="panel rs-inline-block rs-wd-s14 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
          </ng-template>
          <div class="panel rs-panel-big clearfix">
            <mprd-internet-available-options-container></mprd-internet-available-options-container>
          </div>
        </div>
      </div>
    </section>
  </main>
</section>
